import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LoginPage from "./components/LoginPage";
import AdminDashboard from "./Admin/AdminDashboard";
import UserManagement from "./components/UserManagement";
import PasswordReset from "./components/PasswordReset";
import NotificationSendingComponent from "./Admin/NotificationSendingComponent";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./components/LandingPage";
import AdminLayout from "./components/AdminLayout";
import LogViewer from "./components/LogViewer";
import ResourceMonitor from "./components/ResourceMonitor";

const Unauthorized = () => (
  <div className="min-h-screen bg-[#FAF9FF] flex items-center justify-center px-4">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-[#0E0444] mb-4">Access Denied</h1>
      <p className="text-[#4C4D5E] mb-8">
        You don't have permission to access this page.
      </p>
      <a href="/" className="text-[#0C60F2] hover:text-[#0A4ED1] font-medium">
        Return to Home
      </a>
    </div>
  </div>
);

const AdminRoutes = () => (
  <AdminLayout>
    <Routes>
      <Route index element={<AdminDashboard />} />
      <Route path="dashboard" element={<AdminDashboard />} />
      <Route
        path="users"
        element={
          <ProtectedRoute allowedRoles={["superadmin"]}>
            <UserManagement />
          </ProtectedRoute>
        }
      />
      <Route path="notifications" element={<NotificationSendingComponent />} />
      <Route path="password-reset" element={<PasswordReset />} />
      <Route path="logs" element={<LogViewer />} />
      <Route path="resouces-monitor" element={<ResourceMonitor />} />
    </Routes>
  </AdminLayout>
);

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected admin routes */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminRoutes />
              </ProtectedRoute>
            }
          />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { AuthProvider } from './context/AuthContext';
// import LoginPage from './components/LoginPage';
// import AdminDashboard from "../src/Admin/AdminDashboard";
// import ProtectedRoute from './components/ProtectedRoute';
// import LandingPage from './components/LandingPage';

// // Add an Unauthorized component for role-based access control
// const Unauthorized = () => (
//   <div className="min-h-screen bg-[#FAF9FF] flex items-center justify-center px-4">
//     <div className="text-center">
//       <h1 className="text-4xl font-bold text-[#0E0444] mb-4">Access Denied</h1>
//       <p className="text-[#4C4D5E] mb-8">You don't have permission to access this page.</p>
//       <a
//         href="/"
//         className="text-[#0C60F2] hover:text-[#0A4ED1] font-medium"
//       >
//         Return to Home
//       </a>
//     </div>
//   </div>
// );

// const App = () => {
//   return (
//     <AuthProvider>
//       <Router>
//         <Routes>
//           {/* Public routes */}
//           <Route path="/" element={<LandingPage />} />
//           {/* <Route path="/dashboard" element={<AdminDashboard />} />   */}

//           <Route path="/login" element={<LoginPage />} />
//           <Route path="/unauthorized" element={<Unauthorized />} />

//           {/* Protected routes */}
//           <Route
//             path="/admin/*"
//             element={
//               <ProtectedRoute>
//                 <AdminDashboard />
//               </ProtectedRoute>
//             }
//           />

//           {/* Super admin only routes */}
//           <Route
//             path="/admin/users"
//             element={
//               <ProtectedRoute allowedRoles={['superadmin']}>
//                 <AdminDashboard />
//               </ProtectedRoute>
//             }
//           />

//           {/* Catch all route */}
//           <Route path="*" element={<Navigate to="/" replace />} />
//         </Routes>
//       </Router>
//     </AuthProvider>
//   );
// };

// export default App;
